import { Check } from "lucide-react";

export const DIWALI_TIERS = [
  { amount: 100, label: "A Diwali meal for 4 rescued dogs" },
  { amount: 500, label: "A Diwali meal for 20 rescued dogs" },
  { amount: 1000, label: "A Diwali meal for 40 rescued dogs", recommended: true },
  { amount: 3000, label: "A Diwali meal for 120 rescued dogs" },
  { amount: 5000, label: "A Diwali meal for 200 rescued dogs" },
];

export function DiwaliTierPicker({ selectedAmount, hasCustomAmount, onSelect, testIdPrefix = "diwali" }) {
  return (
    <div className="space-y-2.5" data-testid={`${testIdPrefix}-tier-picker`}>
      {DIWALI_TIERS.map((tier) => {
        const active = !hasCustomAmount && selectedAmount === tier.amount;
        return (
          <button
            key={tier.amount}
            type="button"
            onClick={() => onSelect(tier.amount)}
            data-testid={`${testIdPrefix}-tier-${tier.amount}`}
            className={`w-full flex items-center gap-3 rounded-2xl border px-4 py-3.5 text-left transition-all ${
              active
                ? "border-amtm-teal bg-amtm-teal/[0.06] ring-1 ring-amtm-teal"
                : "border-amtm-border hover:border-amtm-teal/50"
            }`}
          >
            <span
              className={`shrink-0 h-5 w-5 rounded-full border-2 flex items-center justify-center transition-colors ${
                active ? "border-amtm-teal bg-amtm-teal" : "border-amtm-border"
              }`}
            >
              {active && <Check className="h-3 w-3 text-white" strokeWidth={3} />}
            </span>
            <span className="flex-1">
              <span className="flex items-center gap-2">
                <span className="font-display text-lg text-amtm-text">₹{tier.amount.toLocaleString("en-IN")}</span>
                {tier.recommended && (
                  <span className="text-[10px] font-bold uppercase tracking-wide bg-[#FFD85F] text-[#1F0E06] px-2 py-0.5 rounded-full">
                    Recommended
                  </span>
                )}
              </span>
              <span className="block text-xs text-amtm-textMuted mt-0.5">{tier.label}</span>
            </span>
          </button>
        );
      })}
    </div>
  );
}
